import React, { useEffect } from 'react';
import Navigation from './Navigation';
import Footer from './Footer';
import PartnersSection from './PartnersSection';
import { useLocation } from 'react-router-dom';
import { AmbientBackground, GrainOverlay } from './Creative';
import WhatsAppFloat from './WhatsAppFloat';
import QueryPopup from './QueryPopup';
import { useContentSettings } from '../hooks/useContentSettings';

const Layout = ({ children }) => {
  const { pathname } = useLocation();
  const cms = useContentSettings();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' in window ? 'instant' : 'auto' });
  }, [pathname]);
  // Home renders its own Partners section right below the hero — every other
  // page under this layout gets the compact strip above the footer.
  const showPartnersStrip = pathname !== '/';
  return (
    <div className="relative min-h-screen flex flex-col overflow-x-clip">
      <AmbientBackground />
      <GrainOverlay />
      {/* Announcement strip — driven by Admin CMS. Rendered ABOVE the nav
          so it never overlaps content; nav sticky offset unaffected. */}
      {cms.announcement_banner && (
        <div className="relative z-[5] bg-[var(--walnut)] text-white text-center px-4 py-2.5 text-[11.5px] tracking-[0.05em]" data-testid="announcement-banner">
          <span className="inline-flex items-center gap-2">
            <span aria-hidden className="w-1.5 h-1.5 bg-[#C9A56C] animate-pulse rounded-full" />
            {cms.announcement_banner}
          </span>
        </div>
      )}
      <Navigation />
      <main className="flex-1 relative z-[2]">{children}</main>
      {showPartnersStrip && <PartnersSection variant="strip" />}
      <Footer />
      <QueryPopup />
      <WhatsAppFloat />
    </div>
  );
};

export default Layout;
